<template>
  <Reference
    :id="value && value.id"
    :value="value"
    :label="label || 'Типи воронки продажів'"
    :placeholder="placeholder || 'Введіть найменування'"
    :items.sync="items"
    :total-items="totalItems"
    :hide-details="hideDetails"
    :error-messages="errorMessages"
    :multiple-select="multipleSelect"
    component-name="SalesFunnelType"
    @input="$emit('input', $event)"
    @getItems="getItems"
  />
</template>

<script>
import * as salesFunnelTypesApi from "../../backend/salesFunnelTypesApi.js";
import Reference from "@/components/Reference";

export default {
  components: {
    Reference,
  },
  props: {
    label: {
      type: String,
      default: "Співробітник",
    },
    value: {
      type: [Object, Array],
    },
    placeholder: {
      type: String,
      default: "",
    },
    hideDetails: {
      type: Boolean,
      default: true,
    },
    errorMessages: {
      type: Array,
    },
    multipleSelect: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    totalItems: 0,
    items: [],
  }),
  methods: {
    async getItems({ currentPage, perPage, search }) {
      const { result, totalItems } = await salesFunnelTypesApi.selectType(
        currentPage,
        perPage,
        search
      );
      this.items = [...this.items, ...result];
      this.totalItems = totalItems;
    },
  },
};
</script>
